import type { MenuItemProps } from '@mui/material';
import { MenuItem as MUIMenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef, useMemo } from 'react';
import { Analytics } from '@/shared/lib';
import { useSavedPresetsContext } from '../SavedPresetsContext/SavedPresetsContext';

const MenuItem = styled(MUIMenuItem)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
}));

interface Props {
  presetId: string;
}

export const DefaultPresetMenuItem = forwardRef<
  HTMLLIElement,
  Props & MenuItemProps
>(function DefaultPresetMenuItem({ presetId, ...menuItemProps }, ref) {
  const { presets, setAsDefault, unsetAsDefault } = useSavedPresetsContext();
  const preset = useMemo(() => {
    return presets.find((p) => p.id === presetId);
  }, [presets, presetId]);
  const isDefault = preset?.isDefault;

  const handleSetAsDefault = () => {
    setAsDefault(presetId);
    Analytics.sendFeatureUsage('saved_views', 'set_as_default');
  };
  const handleUnsetAsDefault = () => {
    unsetAsDefault(presetId);
    Analytics.sendFeatureUsage('saved_views', 'unset_as_default');
  };

  return isDefault ? (
    <MenuItem ref={ref} onClick={handleUnsetAsDefault} {...menuItemProps}>
      Unset as default
    </MenuItem>
  ) : (
    <MenuItem ref={ref} onClick={handleSetAsDefault} {...menuItemProps}>
      Set as default
    </MenuItem>
  );
});
